// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"nb2jy","value":"o5Edv","color":"nNFrN"};